<template>
  <b-table
      small
      :items="tracks"
      :fields="trackColumns"
      show-empty
      empty-text="Нет треков"
      class="mb-0"
  >
    <template #cell(artists)="data">
      <span v-for="(artist, index) in data.item.artists" :key="index">
        <b-link
            v-if="artist.id"
            :to="{name: 'artist-view', params: {id: artist.id}}"
            class="font-weight-bold"
        >{{ artist.name }}</b-link>
        <span v-else>
          {{ artist.name }}
          <b-button
              v-if="artist.name && artist.name !== '.'"
              :to="{name: 'artists-search', query: {q: artist.name}}"
              variant="info"
              class="btn-icon ml-50"
              size="sm"
          >
            <feather-icon icon="SearchIcon"/>
          </b-button>
        </span>
        <span v-if="index < data.item.artists.length - 1">, </span>
      </span>
    </template>

    <template #cell(title)="data">
      <b-link
          v-if="data.item.id && $can('view', 'track-view')"
          :to="{name: 'track-detail', params: {id: data.item.id}}"
          class="font-weight-bold"
      >{{ data.item.title }}</b-link>
      <span v-else>{{ data.item.title }}</span>
      <b-link
          :href="trackUrl(data.item)"
          target="_blank"
          class="ml-50 text-yandex"
      >
        <feather-icon icon="ExternalLinkIcon"/>
      </b-link>
    </template>

    <template #cell(duration)="data">
      <span class="text-nowrap">{{ formatDuration(data.item.duration_ms / 1000) }}</span>
    </template>

    <template #cell(actions)="data">
      <b-button
          v-if="!data.item.id"
          :variant="(data.item.artists && data.item.artists[0] && data.item.artists[0].id) ? 'success' : 'warning'"
          class="btn-icon"
          size="sm"
          @click="$emit('add-track', data.item)"
      >
        <feather-icon icon="PlusIcon"/>
      </b-button>
    </template>
  </b-table>
</template>

<script>
import {BButton, BLink, BTable} from 'bootstrap-vue'
import {formatDuration} from '@core/utils/filter'

export default {
  components: {
    BButton,
    BLink,
    BTable,
  },
  props: {
    tracks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      trackColumns: [
        {key: 'artists', label: 'Артисты'},
        {key: 'title', label: 'Название'},
        {key: 'duration', label: 'Время'},
        {key: 'actions', label: ''},
      ],
    }
  },
  methods: {
    formatDuration,
    trackUrl(track) {
      return track.album_id
        ? `https://music.yandex.ru/album/${track.album_id}/track/${track.track_id}`
        : `https://music.yandex.ru/track/${track.track_id}`
    },
  },
}
</script>
